module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "announce-detail",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.detail.videos && _vm.detail.videos.length) ? _c('section', {
    staticClass: "video-wrap"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": "video-player",
      "controls": "",
      "poster": _vm.detail.coverPic
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.detail.videos && _vm.detail.videos.length ? _vm.detail.videos[0].content : '',
      "type": "application/x-mpegURL"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "announce-desc"
  }, [_c('header', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.detail.files), function(file) {
    return _c('button', {
      key: file.src,
      staticClass: "btn-sm btn btn-preview",
      on: {
        "click": function($event) {
          _vm.previewAttachment(file)
        }
      }
    }, [_vm._v("查看课件")])
  }), _vm._v(" "), _c('h2', {
    staticClass: "announce-title"
  }, [_vm._v(_vm._s(_vm.detail.title))])], 2), _vm._v(" "), _c('section', [_c('section', {
    staticClass: "online-time"
  }, [_vm._v(_vm._s(_vm._f("timeformat")(_vm.detail.onlineTime, 'yyyy-MM-dd')))]), _vm._v(" "), _c('section', {
    ref: "richText",
    staticClass: "image-text",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.contentText)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-382a87d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/AnnounceDetail.vue
// module id = 988
// module chunks = 0